import Api from "@/repository/api";

import { IProductsTaxRepository } from '@/repository/warehouse/Tax/TaxRepository.types'
import { IProductsTaxItem, ProductsTaxResponse } from '@/entity/warehouse/Products/Tax/Tax.types'
import ProductsTaxTypes from "@/entity/warehouse/Products/Tax/Tax";

export class ProductsTaxRepository implements IProductsTaxRepository {
    async fetchAll(): Promise< IProductsTaxItem[]> {
        const response = await Api.get('/tax/get');
        const responseData = response.data as ProductsTaxResponse[];
        return responseData.map((data: ProductsTaxResponse) => new ProductsTaxTypes(data));
    }
}